module.exports = __webpack_public_path__ + "img/logo.7dbd11f1.png";